const datums = {
  id: "datums",
  label: "Datums",
  endpoint: "datums",
  columnConfig: [
    {
      field: "name",
      headerName: "Datum",
      width: 250,
      description: "Datum",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default datums;
